import { useEffect } from 'react';

import { useShortURL } from 'lib/hooks/useShortURL';

function useShortURLToolTip(url: string, isOpen: boolean) {
  const { error, loading, refetch, shortURL } = useShortURL(url);

  useEffect(() => {
    if (isOpen && url) {
      // Only attempt URL shortening if we have a valid URL
      refetch().catch(err => {
        // Silently handle errors to prevent tooltip disruption
        console.warn('URL shortening failed:', err);
      });
    }
  }, [isOpen, url, refetch]);

  return { shortURL, loading, error };
}

export default useShortURLToolTip;
